import React from "react";
import LeagMainHead from "../../common/LeagMainHead";
import InfoPage from "../../football/league/InfoPage";
import LeagueWrapper from "../../football/league/LeagueWrapper";
import IceHockeyStandingTable from "../../common/table/IceHockeyStandingTable";

const IceHockeyLeagueWidgetWrap = (props) => {
    const {
        dataId,
        dataType,
        head,
        data,
        headData,
        baseUrl,
        sport,
        difference,
        loadCSS,
        dataClient,
        websiteBaseUrl,
        dataPath,
        dataTitle,
        setDataType,
        setDataId,
        setHead,
    } = props;

    const renderHeadWrap = (currentTab, children) =>
        head ? (
            <LeagMainHead
                id={dataId}
                headData={headData}
                baseUrl={baseUrl}
                sport={"icehockey"}
                dataClient={dataClient}
                currentTab={currentTab}
                websiteBaseUrl={websiteBaseUrl}
                dataPath={dataPath}
                widgetTitle={dataTitle}
            >
                {children}
            </LeagMainHead>
        ) : (
            children
        );

    switch (dataType) {
        case "icehockey-league-info":
            return renderHeadWrap("info",
                <InfoPage
                    id={dataId}
                    sport={sport}
                    data={data}
                    loadCSS={loadCSS}
                    baseUrl={baseUrl}
                    setDataType={setDataType}
                    setDataId={setDataId}
                    setHead={setHead}
                    dataClient={dataClient}
                    websiteBaseUrl={websiteBaseUrl}
                    dataPath={dataPath}
                    difference={difference}
                />
            );

        case "icehockey-league-upcoming":
            return renderHeadWrap("upcoming",
                <LeagueWrapper
                    sport={sport}
                    data={data?.data}
                    loadCSS={loadCSS}
                    baseUrl={baseUrl}
                    dataClient={dataClient}
                    websiteBaseUrl={websiteBaseUrl}
                    dataPath={dataPath}
                    difference={difference}
                />
            );

        case "icehockey-league-results":
            return renderHeadWrap("results",
                <LeagueWrapper
                    sport={sport}
                    data={data?.data}
                    loadCSS={loadCSS}
                    baseUrl={baseUrl}
                    dataClient={dataClient}
                    websiteBaseUrl={websiteBaseUrl}
                    dataPath={dataPath}
                    difference={difference}
                />
            );
        case "icehockey-league-standings":
            return renderHeadWrap("table",
                <IceHockeyStandingTable
                    sport={sport}
                    ServerData={data?.data}
                    loadCSS={loadCSS}
                    dataClient={dataClient}
                    websiteBaseUrl={websiteBaseUrl}
                    dataPath={dataPath}
                />
            );

        default:
            return <h1>Basketball League Widget Not Found!</h1>;
    }
};

export default IceHockeyLeagueWidgetWrap;
